// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","screen-sm":"1024px","screen-lg":"1680px","boxContentBg":"#471448","boxHeaderBg":"#3d0c3e"};